<template>
	<div class="match-block" v-if="match">
		<div class="wrapper">
			<h1 class="match-block_title" v-text="match.stage_name"></h1>
			
			<p class="match-block_date" v-text="getTime(match.startdate)"></p>
			
			<div class="match-block-wrapper">
				<div class="match-block_item match-block_item_orange">
					<div class="match-block_item-bg" style="background-image: url('https://svirtus.cdnvideo.ru/sdlNVLO-8LR2bYodSEAOxFEVz8U=/0x0:200x200/150x150/filters:quality(100)/https://hb.bizmrg.com/esports-core-media/27/27afc4515bd8174b24a8077a3d1610d2.png?m=8899e03340904a438ccc1c36846bdf39');"></div>
					<div class="match-block_item-flag"></div>
					<div class="match-block_item-info match-block_item-info_first">
						<a href="" class="match-block-team">
							<div class="match-block-team_name" v-text="match.home_name"></div>
							<div class="match-block-team_logo">
								<img :src="$hostname + match.home_image_ref" alt="">
							</div>
						</a>
						<div class="match-block_item-result" v-text="match.home_score"></div>
					</div>
					<div class="match-block_item-list">
						<a href="" target="_blank" class="match-block-player" v-for="lineup in match.lineups.start" :key="'home-' + lineup.home.name">
							<div class="match-block-player_about">
								<div class="match-block-player_about-header">
									<div class="match-block-player_about-flag flag-icon flag-icon-fr"></div>
									<div class="match-block-player_about-nickname" v-text="lineup.home.name"></div>
								</div>
							</div>
						</a>
					</div>
				</div>
				<div class="match-block_item match-block_item_gray">
					<div class="match-block_item-bg" style="background-image: url('https://svirtus.cdnvideo.ru/36jFGmb_HDFn7QCk2ZLWWG95W4k=/0x0:280x280/150x150/filters:quality(100)/https://hb.bizmrg.com/esports-core-media/f0/f04711c435a411faa83b75c33eb81e50.png?m=bc95758483090a7d39a2f94142028370');"></div>
					<div class="match-block_item-flag"></div>
					<div class="match-block_item-info match-block_item-info_second">
						<a href="" class="match-block-team">
							<div class="match-block-team_name" v-text="match.away_name"></div>
							<div class="match-block-team_logo">
								<img :src="$hostname + match.away_image_ref" alt="Fnatic">
							</div>
						</a>
						<div class="match-block_item-result" v-text="match.away_score"></div>
					</div>
					<div class="match-block_item-list">
						<a href="" target="_blank" class="match-block-player" v-for="lineup in match.lineups.start" :key="'away-' + lineup.away.name">
							<div class="match-block-player_about">
								<div class="match-block-player_about-header">
									<div class="match-block-player_about-flag flag-icon flag-icon-se"></div>
									<div class="match-block-player_about-nickname" v-text="lineup.away.name"></div>
								</div>
							</div>
						</a>
					</div>
				</div>
			</div>
			
			<div class="statistic">
				<table class="statistic_table">
					<thead>
						<tr>
							<th>Герой</th>
							<th>Игрок</th>
							<th>У</th>
							<th>С</th>
							<th>П</th>
						</tr>
					</thead>
				</table>
				
				<div class="statistic_header">
					<span class="statistic_color-1">Свет:</span>
					Evil Geniuses
				</div>
				
				<table class="statistic_table">
					<tbody>
						<tr>
							<td>
								<div class="statistic_image">
									<img src="/img/3.png" alt="">
									<div class="statistic_lvl">20</div>
								</div>
							</td>
							<td>
								<div class="statistic_name">Arteezy</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="statistic_image">
									<img src="/img/3.png" alt="">
									<div class="statistic_lvl">20</div>
								</div>
							</td>
							<td>
								<div class="statistic_name">Arteezy</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="statistic_image">
									<img src="/img/3.png" alt="">
									<div class="statistic_lvl">20</div>
								</div>
							</td>
							<td>
								<div class="statistic_name">Arteezy</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
						</tr>
					</tbody>
				</table>
				
				<div class="statistic_header">
					<span class="statistic_color-2">Свет:</span>
					Evil Geniuses
				</div>
				
				<table class="statistic_table _2">
					<tbody>
						<tr>
							<td>
								<div class="statistic_image">
									<img src="/img/3.png" alt="">
									<div class="statistic_lvl">20</div>
								</div>
							</td>
							<td>
								<div class="statistic_name">Arteezy</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="statistic_image">
									<img src="/img/3.png" alt="">
									<div class="statistic_lvl">20</div>
								</div>
							</td>
							<td>
								<div class="statistic_name">Arteezy</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="statistic_image">
									<img src="/img/3.png" alt="">
									<div class="statistic_lvl">20</div>
								</div>
							</td>
							<td>
								<div class="statistic_name">Arteezy</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
							<td>
								<div class="statistic_value">2</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			
			<div class="statistic-dota2">
				<div class="nav __base">
					<div class="nav_list">
						<a href="#" @click.prevent="changeTab(tabKey)" v-for="tabKey in tabKeys" :key="tabKey" v-text="tabKey" :class="{'router-link-active': tabKey === activeTab}"></a>
					</div>
				</div>
				
				<div class="tab_blocks">
					<div class="tab_block" v-for="tabKey in tabKeys" :class="{active: tabKey === activeTab}" :key="'block-' + tabKey">
						<div class="statistic-dota2__content">
							<header class="flex-box justify-content--center align-items--stretch statistic-dota2__header">
								<div class="flex-box align-items--stretch align-self--center justify-content--flex-end statistic-dota2__team">
									<div class="margin-right--20 align-self--center text-align--right">
										<strong class="color--brand-orange" v-if="isWinner('home')">Победа</strong>
										<strong class="inverse-color--gray-01" v-if="!isWinner('home')">Поражение</strong>
										<h4 v-text="match.home_name"></h4>
									</div>
									<div class="icon--container icon--container-100" :style="'background-image: url(' + $hostname + match.home_image_ref + ');'"></div>
								</div>
								<div class="align-self--center text-align--center">
									<strong class="inverse-color--gray-01" v-if="!isWinner('home') && !isWinner('away')">Ничья</strong>
									
									<div class="align-self--center text-align--center">
										<div class="statistic-dota2__match-info">
											<div class="statistic-dota2__score">
												<strong class="match-statistics__score-round" 
														:class="[isWinner('home') ? '__color-1' : '__color-2']" 
														v-text="results[activeTab]['home'][0]['sr_value']"></strong>
												
												<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 5 12" width="5">
													<g fill="#8a8a8a" id="icon-colon" fill-rule="evenodd">
														<path d="M2.5 5C1.1192881 5 0 3.8807119 0 2.5S1.1192881 0 2.5 0 5 1.1192881 5 2.5 3.8807119 5 2.5 5zm0 7C1.1192881 12 0 10.8807119 0 9.5S1.1192881 7 2.5 7 5 8.1192881 5 9.5 3.8807119 12 2.5 12z"></path>
													</g>
												</svg>
												
												<strong class="match-statistics__score-round" 
														:class="[isWinner('away') ? '__color-1' : '__color-2']" 
														v-text="results[activeTab]['away'][0]['sr_value']"></strong>
											</div>
											<div class="statistic-dota2__time" v-text="activeTab"></div>
										</div>
									</div>
								</div>
								<div class="flex-box align-items--stretch align-self--center statistic-dota2__team">
									<div class="icon--container icon--container-100" :style="'background-image: url(' + $hostname + match.away_image_ref + ');'"></div>
									<div class="margin-left--20 align-self--center">
										<strong class="color--brand-orange" v-if="isWinner('away')">Победа</strong>
										<strong class="inverse-color--gray-01" v-if="!isWinner('away')">Поражение</strong>
										<h4 v-text="match.away_name"></h4>
									</div>
								</div>
							</header>
							
							<div class="match-statistics">
								<div class="csgo-stast">
									<div class="csgo-stast__team csgo-stast__team_top">
										<div class="icon--container icon--container-24 margin-right--10" :style="'background-image: url(' + $hostname + match.home_image_ref + ');'"></div>
										
										<div class="csgo-stast__round" v-for="key in 30" :key="'csgo-stast-home-' + key">
											<div v-if="homeResults[key]">
												<icons :value="homeResults[key]['sr_value']" :round="results[activeTab]['home'][key]"></icons>
											</div>
										</div>
									</div>
									
									<div class="csgo-stast__team csgo-stast__team_bottom">
										<div class="icon--container icon--container-24 margin-right--10" :style="'background-image: url(' + $hostname + match.away_image_ref + ');'"></div>
										
										<div class="csgo-stast__round" v-for="key in 30" :key="'csgo-stast-away-' + key">
											<div v-if="awayResults[key]">
												<icons :value="awayResults[key]['sr_value']" :round="results[activeTab]['away'][key]"></icons>
											</div>
										</div>
									</div>
								</div>
								
								<div class="csgo-players-stats">
									<div class="csgo-players-stats__team">
										<div class="csgo-players-stats__team-info">
											<div class="csgo-players-stats__team-info__item">
												<div class="flex-box">
													<div class="icon--container icon--container-18 margin-right--10" style='background-image: url("https://svirtus.cdnvideo.ru/DWOQ9Vi28nA0j4Di3UAYomWKVso=/0x0:200x200/filters:quality(100)/https://hb.bizmrg.com/esports-core-media/27/27afc4515bd8174b24a8077a3d1610d2.png?m=8899e03340904a438ccc1c36846bdf39");'></div>
													<div>Team Vitality</div>
												</div>
											</div>
											<div class="csgo-players-stats__team-info__item">K</div>
											<div class="csgo-players-stats__team-info__item">D</div>
											<div class="csgo-players-stats__team-info__item">A</div>
										</div>
										<div class="csgo-players-stats__item">
											<div class="csgo-players-stats__col">
												<div class="csgo-players-stats__col-info">
													<div class="match-duel-player__photo margin-right--16">
														<img
														src="https://svirtus.cdnvideo.ru/qQyW1-dju5EPlveTssFeigGgFQA=/0x0:300x300/200x200/filters:quality(100)/https://hb.bizmrg.com/esports-core-media/03/03aba6b0826f144b7bf0ad102cdb50a1.jpg?m=90fc7f07fa1b2791c4fcf663e432c690"
														alt="shox">
													</div>
													<div class="match-duel-player__about">
														<div class="match-duel-player__about-header">
															<div
															class="match-duel-player__about-nickname margin-right--8">shox
															</div>
															<div
															class="match-duel-player__about-flag flag-icon flag-icon-fr"></div>
														</div>
														<div class="match-duel-player__about-name">Ришар Папильон</div>
													</div>
												</div>
											</div>
											<div class="csgo-players-stats__col" data-type="kill">21</div>
											<div class="csgo-players-stats__col" data-type="death">13</div>
											<div class="csgo-players-stats__col">4</div>
										</div>
									</div>
									
									
									<div class="csgo-players-stats__team">
										<div class="csgo-players-stats__team-info">
											<div class="csgo-players-stats__team-info__item">
												<div class="flex-box">
													<div class="icon--container icon--container-18 margin-right--10" style='background-image: url("https://svirtus.cdnvideo.ru/OAR5gGvrszaak07TLzwkYPrJT9w=/0x0:280x280/filters:quality(100)/https://hb.bizmrg.com/esports-core-media/f0/f04711c435a411faa83b75c33eb81e50.png?m=bc95758483090a7d39a2f94142028370");'>
													</div>
													<div>Fnatic</div>
												</div>
											</div>
											<div class="csgo-players-stats__team-info__item">K</div>
											<div class="csgo-players-stats__team-info__item">D</div>
											<div class="csgo-players-stats__team-info__item">A</div>
										</div>
										<div class="csgo-players-stats__item">
											<div class="csgo-players-stats__col">
												<div class="csgo-players-stats__col-info">
													<div class="match-duel-player__photo">
														<img src="https://svirtus.cdnvideo.ru/1_IYgGbhB4sQy3szuFusku0r6oA=/0x0:200x200/200x200/filters:quality(100)/https://hb.bizmrg.com/esports-core-media/c4/c4643dfb54839bcc6da5b5b3597e4145.png?m=2b949254b378ea7b4e34f0ca1e68953b"
														alt="KRiMZ">
													</div>
													<div class="match-duel-player__about">
														<div class="match-duel-player__about-header">
															<div class="match-duel-player__about-nickname margin-right--8">KRiMZ
															</div>
															<div class="match-duel-player__about-flag flag-icon flag-icon-se"></div>
														</div>
														<div class="match-duel-player__about-name">Фредди Йоханссон</div>
													</div>
												</div>
											</div>
											<div class="csgo-players-stats__col" data-type="kill">14</div>
											<div class="csgo-players-stats__col" data-type="death">19</div>
											<div class="csgo-players-stats__col">3</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import _ from 'underscore';
	
	import Icons from "../components/Match/Scgo/Stat/Icons";

	export default {
		components: {
			Icons
		},
		
		data() {
			return {
				match: null,
				results: null,
				tabKeys: null,
				activeTab: null,
			}
		},

		created() {
			this.axios.get('/api/events/' + this.$route.params.id)
				.then(({data}) => {
					this.match = data;
				});
			this.axios.get('/api/scopes_results/' + this.$route.params.id)
				.then(({data}) => {
					this.results = data;
					
					this.tabKeys = _.keys(this.results);
					this.activeTab = this.tabKeys[0];
				});
		},

		methods: {
			getTime(time) {
				return moment(time).locale('ru').format('D MMMM Y, HH:mm')
			},
			changeTab(tab) {
				this.activeTab = tab;
			},
			isWinner(team) {
				let opponent = team === 'home' ? 'away' : 'home';
				return Number(this.results[this.activeTab][team][0]['sr_value']) > Number(this.results[this.activeTab][opponent][0]['sr_value']);
			}
		},
		computed: {
			homeResults() {
				let data = {};
				
				let res =  this.results[this.activeTab]['home'].filter((value) => {
					return value['sdt_description'].search('Win Type Play') !== -1;
				});
				
				res.forEach((value) => {
					let index = value['sdt_description'].match(/\d+/)[0];
					
					data[index] = value;
				});
				
				return data;
			},
			awayResults() {
				let data = {};
				
				let res =  this.results[this.activeTab]['away'].filter((value) => {
					return value['sdt_description'].search('Win Type Play') !== -1;
				});
				
				res.forEach((value) => {
					let index = value['sdt_description'].match(/\d+/)[0];
					
					data[index] = value;
				});
				
				return data;
			},
		}
	}
</script>

<style scoped>

</style>